import request from '@/utils/requestnew'
import baseUrl from './baseUrl'
import commonJs from '@/utils/common'

const BASE_URL = baseUrl + '/auth'

export default {
    //列表接口
    getPageList(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/getPageList',
            method: 'get',
            params
        })
    },

    //获取中心和角色列表
    getInfo(params = {}) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/getInfo',
            method: 'get',
            params
        })
    },

    //添加
    add(data) {
        return request({
            url: BASE_URL + '/add',
            method: 'post',
            data
        })
    },

    //编辑
    update(data) {
        return request({
            url: BASE_URL + '/update',
            method: 'post',
            data
        })
    },

    //删除
    delete(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/delete',
            method: 'get',
            params
        })
    },

    //重置密码
    pwd(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/updatePwd',
            method: 'get',
            params
        })
    },


}